export default __webpack_public_path__ + "static/media/hero-image.e6dff428.webp";